import PropTypes from 'prop-types'
/* eslint react/prefer-stateless-function: 0 */

import React, { Component } from 'react'
import { intlShape, FormattedHTMLMessage } from 'react-intl'
import memoizeIntlConstructor from 'intl-format-cache'
import { getValues, getMessage, stripMessageHTML } from './util'

let gnf

export default function format (convertedValue, { locale, digits, numberOptions, clockDisplay }) {
  const getNumberFormat = gnf || memoizeIntlConstructor(window.Intl.NumberFormat)

  // allow users to override numberOptions
  // default to the 'digits' parameter
  const options = numberOptions
    ? numberOptions
    : { maximumFractionDigits: digits, minimumFractionDigits: digits }

  const numberFormat = getNumberFormat(locale, options)
  let formattedValue = numberFormat.format(convertedValue)

  if (clockDisplay) {
    const secondVal = convertedValue % 1
    const minutes = Math.floor(convertedValue)
    let seconds = Math.floor(60 * secondVal)
    seconds = seconds.toString().length === 2 ? seconds : `0${seconds}`
    formattedValue = `${minutes}:${seconds}`
  }

  return formattedValue
}

export class FormattedUnit extends Component {

  static contextTypes = {
    intl: intlShape.isRequired,
    locale: PropTypes.string.isRequired,
  };

  static propTypes = {
    from: PropTypes.string,
    to: PropTypes.string,
    digits: PropTypes.number,
    numberOptions: PropTypes.object,
    value: PropTypes.number,
    unit: PropTypes.string,
    clockDisplay: PropTypes.bool,
  };

  render () {
    const { locale } = this.context
    const { value, to, from, unit, digits, numberOptions, clockDisplay } = this.props
    const values = getValues({ value, locale, from, to, digits, numberOptions, clockDisplay })
    const message = getMessage({ to, unit })
    return React.createElement(FormattedHTMLMessage, { ...message, values })
  }

}

export function formatUnit ({ intl, locale, value, to, from, unit, digits, numberOptions }) {
  const values = getValues({ value, locale, from, to, digits, numberOptions })
  const message = getMessage({ to, unit })
  const formattedUnit = intl.formatMessage(message, values)
  return stripMessageHTML(formattedUnit)
}



// WEBPACK FOOTER //
// ./src/shared/units/format.js